module.exports = __webpack_public_path__ + "img/CFBG2.3c92cb6f.png";